// Route constants for better organization
export const ROUTES = {
  // Public routes
  HOME: "/",
  ABOUT: "/about",

  // Auth routes
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  CONFIRM_EMAIL: "/confirm-email",
  EMAIL_CONFIRMED: "/email-confirmed",
  AUTH_ACTION: "/auth-action",
  ACCOUNT_SETUP: "/account-setup",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_CHECK_EMAIL: "/forgot-password/check-email",
  CREATE_NEW_PASSWORD: "/create-new-password",
  RESET_PASSWORD: "/reset-password",

  // Dashboard routes
  DASHBOARD: "/dashboard",

  // Profile routes
  MY_PROFILE: "/my-profile",
  EDIT_PROFILE: "/edit-profile",

  // Game routes
  CREATE_GAME: "/create-game",
  EDIT_GAME: "/edit-game/:gameId",
  UPCOMING_GAMES: "/upcoming",
  GAME_HISTORY: "/game-history",
  GAME_SUCCESS: "/game-success",
  GAME_DETAILS: "/game-details/:gameId",
  REVIEW_BOOKING: "/review-booking",
  GENERATING_TEAMS: "/generating-teams/:gameId",
  MANAGE_TEAMS: "/manage-teams/:gameId",
  INVITE_MEMBERS: "/invite-members",

  // Group routes
  VIEW_GROUP: "/group/:groupId",
  EDIT_GROUP: "/group/:groupId/edit",

  // Settings routes
  SETTINGS: "/settings",
  SETTINGS_EMAIL: "/settings/email",
  SETTINGS_PASSWORD: "/settings/password",
  SETTINGS_PASSWORD_CHECK_EMAIL: "/settings/password/check-email",
  SETTINGS_NOTIFICATIONS: "/settings/notifications",
  SETTINGS_DELETE_ACCOUNT: "/settings/delete-account",

  // Payment routes
  PAYMENTS: "/payments",
  MY_PAYMENTS: "/payments/my-payments",
  EARNINGS: "/payments/earnings",
  SETUP_PAYOUT: "/payments/setup",
  PAYOUT_GETTING_STARTED: "/payments/getting-started",
  CONNECT_STRIPE_ACCOUNT: "/connect-stripe-account",

  // Development
  COMPONENTS: "/components",

  // Error pages
  NOT_FOUND: "/404",
};
